<template>
  <div class="bikes">
    <v-row justify="center">
      <v-col
        :xl="6"
        :lg="8"
        :xs="10"
      >
        <v-row>
          <v-col>
            <h1>Your Bike</h1>
            <p>Start to add your bike (or bikes) that you would like us to service. You can choose a particular service for each bike, as well as add notes. If there are any issues, please be as descriptive as possible, that way we can get to the root of the issue quickly and you can get back to riding!</p>
          </v-col>
        </v-row>

        <v-form
          ref="form"
          v-model="validForm"
        >

          <v-expansion-panels
            v-model="panels"
            mandatory
            multiple
          >
            <v-expansion-panel
              v-for="(bike, bikeKey) in $store.getters.bookingForm.bikes"
              :key="bikeKey"
            >
              <v-expansion-panel-header>{{ form.bikes[bikeKey].manafacturer && form.bikes[bikeKey].model ?  `${form.bikes[bikeKey].manafacturer} - ${form.bikes[bikeKey].model}` : `Bike ${bikeKey + 1}`}}</v-expansion-panel-header>
              <v-expansion-panel-content>

                <!-- Volt parts error -->
                <v-alert
                  v-if="form.bikes[bikeKey].manafacturer === 'volt' || form.bikes[bikeKey].manafacturer === 'Volt'"
                  outlined
                  border="top"
                  type="error"
                >
                  Please note that we can only carry out servicing on Volt bikes, there are currently no replacement parts available for Volt bikes.
                </v-alert>
                <!-- Volt parts error -->

                <BikeForm
                  v-if="servicesLoaded"
                  :bike="form.bikes[bikeKey]"
                  :services="services"
                  :position="bikeKey + 1"
                  @bikeUpdate="updateBookingFormBikeValue($event.value, $event.key, bikeKey)"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-form>

        <v-row class="pt-0">
          <v-col class="pt-0">
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <div>
                <v-btn
                  :loading="loading"
                  class="mt-4 mr-2"
                  large
                  @click="$router.push({ name: 'pageOne' })">
                  Back
                </v-btn>
                <v-btn
                  :loading="loading"
                  color="primary"
                  class="mt-4"
                  large
                  @click="validateAndNext">
                  Next <v-icon right dark>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
              <PaymentRequestBtn
                ref="paymentRequestBtn"
                class="mt-4"
                @loading:changed="paymentLoading => loading = paymentLoading"
                @button:click="handlePaymentRequestBtnClick"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import formPage from '@/views/formPage'
import BikeForm from '@/components/BikeForm'
import PaymentRequestBtn from '@/components/PaymentRequestBtn'

export default {
  name: 'PageTwo',

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$store.getters.bookingForm.bikes.length === 0) {
        vm.$router.push({ name: 'pageOne' })
      }
    })
  },

  mixins: [formPage],

  components: {
    BikeForm,
    PaymentRequestBtn
  },

  data () {
    return {
      validForm: true,
      servicesLoaded: false,
      services: [],
      panels: [],
      loading: false
    }
  },

  mounted () {
    this.$store.getters.bookingForm.bikes.forEach((bike, key) => {
      this.panels.push(key)
    })
    this.getServices()
    this.trackCheckoutStep3()
  },

  methods: {
    trackCheckoutStep3 () {
      window.dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: { step: 3, option: `${this.form.bikes.length} bikes` }
          }
        }
      })
    },

    getServices () {
      this.$api.get({
        path: 'services',
        params: {
          only_live: true
        }
      })
        .then(data => {
          this.$store.commit('setServices', data.data)
          this.services = data.data
          this.servicesLoaded = true
        })
    },

    handlePaymentRequestBtnClick ($e) {
      if (!this.$refs.form.validate()) {
        $e.preventDefault()
      } else {
        $e.callback()
      }
    },

    validateAndNext () {
      if (this.$refs.form.validate()) {
        this.$router.push({ name: 'pageThree' })
      }
    }
  }
}
</script>
